import React, { useState } from "react";
import Swal from "sweetalert2";

const API_URL = process.env.REACT_APP_API_URL;

export default function Footer() {
  const [form, setForm] = useState({
    name: "",
    email: "",
    subject: "",
    message: "",
  });
  const [submitting, setSubmitting] = useState(false);

  const handleChange = (e) =>
    setForm({ ...form, [e.target.id]: e.target.value });

  const alert = (type, title, text) =>
    Swal.fire({
      icon: type,
      title,
      text,
      confirmButtonColor: "#DC2626",
      background: "#0A0A0A",
      color: "#FFFFFF",
    });

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    try {
      const res = await fetch(`${API_URL}/api/send-email`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(form),
      });
      const data = await res.json();
      if (data.success) {
        alert(
          "success",
          "Sent.",
          "Thanks for reaching out — I'll get back to you soon.",
        );
        setForm({ name: "", email: "", subject: "", message: "" });
      } else {
        alert(
          "error",
          "Failed to send.",
          "Something went wrong. Please try again later.",
        );
      }
    } catch {
      alert(
        "error",
        "Network Error",
        "Unable to reach the server. Please try again later.",
      );
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <section className="contact" id="contact">
      <div className="shell">
        <p className="eyebrow">Contact</p>
        <h2 className="section-title">
          Let's <em>connect</em>.
        </h2>

        <div className="contact-grid">
          <div className="contact-info">
            <h4>Email</h4>
            <a href="mailto:anasir.connect@gmail.com">
              anasir.connect@gmail.com
            </a>

            <h4>WhatsApp</h4>
            <a
              href="https://wa.me/923020680606"
              target="_blank"
              rel="noopener noreferrer"
            >
              +92 302 0680606
            </a>

            <h4>Open To</h4>
            <p className="contact-open-to">
              Research collaborations, curatorial projects, creative
              commissions, filmmaking, and writing opportunities.
            </p>

            <div className="contact-social">
              <a
                href="https://www.instagram.com/saazoanasir/"
                target="_blank"
                rel="noopener noreferrer"
                className="contact-social-link contact-social-link--ig"
                aria-label="Instagram"
              >
                <i className="bi bi-instagram" />
              </a>
              <a
                href="https://www.youtube.com/@saazoanasir"
                target="_blank"
                rel="noopener noreferrer"
                className="contact-social-link contact-social-link--yt"
                aria-label="YouTube"
              >
                <i className="bi bi-youtube" />
              </a>
            </div>
          </div>

          <form className="contact-form" onSubmit={handleSubmit}>
            <div className="form-grid-2">
              <div className="field">
                <label htmlFor="name">Name</label>
                <input
                  id="name"
                  type="text"
                  placeholder="Your name"
                  value={form.name}
                  onChange={handleChange}
                  required
                />
              </div>
              <div className="field">
                <label htmlFor="email">Email</label>
                <input
                  id="email"
                  type="email"
                  placeholder="your@email.com"
                  value={form.email}
                  onChange={handleChange}
                  required
                />
              </div>
            </div>
            <div className="field">
              <label htmlFor="subject">Subject</label>
              <input
                id="subject"
                type="text"
                placeholder="What's this about?"
                value={form.subject}
                onChange={handleChange}
                required
              />
            </div>
            <div className="field">
              <label htmlFor="message">Message</label>
              <textarea
                id="message"
                rows="5"
                placeholder="Your message..."
                value={form.message}
                onChange={handleChange}
                required
              />
            </div>
            <button type="submit" className="btn-submit" disabled={submitting}>
              {submitting ? "Sending..." : "Send Message →"}
            </button>
          </form>
        </div>

        <div className="footer-rule">
          © {new Date().getFullYear()} Anas Nasir. All rights reserved.
        </div>
      </div>
    </section>
  );
}
